var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("h5", [_vm._v("Valores de rubros")]),
    _vm._v(" "),
    _vm.recaudacion != null
      ? _c("div", { staticClass: "table-responsive" }, [
          _c("table", [
            _c("tbody", [
              _c("tr", [
                _vm._m(1),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "almuerzo",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.almuerzo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "almuerzo", $$v)
                          },
                          expression: "form.almuerzo"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "pago_carro",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.pago_carro,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "pago_carro", $$v)
                          },
                          expression: "form.pago_carro"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "peaje",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.peaje,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "peaje", $$v)
                          },
                          expression: "form.peaje"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(4),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "gasolina",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.gasolina,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "gasolina", $$v)
                          },
                          expression: "form.gasolina"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "deposito",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.deposito,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "deposito", $$v)
                          },
                          expression: "form.deposito"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("input-field", {
                        attrs: {
                          id: "otros",
                          placeholder: "$ #,###.##",
                          vMoney: "",
                          format: _vm.money
                        },
                        model: {
                          value: _vm.form.otros,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "otros", $$v)
                          },
                          expression: "form.otros"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(7),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.moneyFormat(_vm.totalRubros)))]),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _c("td", { attrs: { colspan: "3" } }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c("textarea-field", {
                        attrs: {
                          id: "observacion_otros",
                          placeholder: "Escriba..."
                        },
                        model: {
                          value: _vm.form.observacion_otros,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "observacion_otros", $$v)
                          },
                          expression: "form.observacion_otros"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("h5", [_vm._v("Galería")]),
    _vm._v(" "),
    _vm.recaudacion != null
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Almuerzo")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_almuerzo" },
                model: {
                  value: _vm.form.foto_almuerzo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_almuerzo", $$v)
                  },
                  expression: "form.foto_almuerzo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Alquiler de vehículo")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_pago_carro" },
                model: {
                  value: _vm.form.foto_pago_carro,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_pago_carro", $$v)
                  },
                  expression: "form.foto_pago_carro"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Peaje")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_peaje" },
                model: {
                  value: _vm.form.foto_peaje,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_peaje", $$v)
                  },
                  expression: "form.foto_peaje"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Combustible")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_gasolina" },
                model: {
                  value: _vm.form.foto_gasolina,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_gasolina", $$v)
                  },
                  expression: "form.foto_gasolina"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Combustible 2")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_gasolina2" },
                model: {
                  value: _vm.form.foto_gasolina2,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_gasolina2", $$v)
                  },
                  expression: "form.foto_gasolina2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Combustible 3")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_gasolina3" },
                model: {
                  value: _vm.form.foto_gasolina3,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_gasolina3", $$v)
                  },
                  expression: "form.foto_gasolina3"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Combustible 4")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_gasolina4" },
                model: {
                  value: _vm.form.foto_gasolina4,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_gasolina4", $$v)
                  },
                  expression: "form.foto_gasolina4"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Otros")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_otros" },
                model: {
                  value: _vm.form.foto_otros,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_otros", $$v)
                  },
                  expression: "form.foto_otros"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Otros 2")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_otros2" },
                model: {
                  value: _vm.form.foto_otros2,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_otros2", $$v)
                  },
                  expression: "form.foto_otros2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Otros 3")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_otros3" },
                model: {
                  value: _vm.form.foto_otros3,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_otros3", $$v)
                  },
                  expression: "form.foto_otros3"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Otros 4")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_otros4" },
                model: {
                  value: _vm.form.foto_otros4,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_otros4", $$v)
                  },
                  expression: "form.foto_otros4"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Depósito")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_deposito" },
                model: {
                  value: _vm.form.foto_deposito,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_deposito", $$v)
                  },
                  expression: "form.foto_deposito"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Depósito 2")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_deposito2" },
                model: {
                  value: _vm.form.foto_deposito2,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_deposito2", $$v)
                  },
                  expression: "form.foto_deposito2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Depósito 3")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_deposito3" },
                model: {
                  value: _vm.form.foto_deposito3,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_deposito3", $$v)
                  },
                  expression: "form.foto_deposito3"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-md-3" },
            [
              _c("h5", [_vm._v("Depósito 4")]),
              _vm._v(" "),
              _c("image-uploader", {
                attrs: { id: "foto_deposito4" },
                model: {
                  value: _vm.form.foto_deposito4,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "foto_deposito4", $$v)
                  },
                  expression: "form.foto_deposito4"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        { staticClass: "btn-success", on: { click: _vm.actualizar } },
        [
          _c("i", { staticClass: "fa fa-save" }),
          _c("span", [_vm._v("Actualizar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cerrar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Rubros de recaudación")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Almuerzo")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Alquiler de vehículo")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Peaje")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Combustible")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Depósito")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Otros")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Observaciones:")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efa26b0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efa26b0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/RubrosRecaudacion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-efa26b0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/RubrosRecaudacion.vue
// module chunks = 0